'use client';

import { Close } from '@radix-ui/react-popover';
import clx from 'classnames';
import { Url } from 'next/dist/shared/lib/router/router';
import Link from 'next/link';
import { FC, ReactNode } from 'react';

type Props = {
	children: ReactNode;
	href: Url;
	onClick?: () => void;
	mobile?: boolean;
	/**
	 * Destaca o item como "pílula": fundo azul claro e borda da marca.
	 * Usado no item da edição corrente do evento, que precisa saltar aos olhos
	 * sem virar um segundo botão sólido competindo com o CTA "Cadastre-se".
	 */
	highlight?: boolean;
};

const NavbarLink: FC<Props> = ({ href = '/', children, onClick, mobile = false, highlight = false }) => {
	const handleClick = () => {
		// Executar callback adicional se fornecido
		if (onClick) {
			onClick();
		}
	};

	const linkElement = (
		<Link
			href={href}
			onClick={handleClick}
			className={clx(
				'flex items-center text-[15px] lg:text-base whitespace-nowrap transition-colors ease-in-out duration-200',
				highlight
					? 'font-bold text-[#0F1DD7] bg-[#0F1DD7]/10 border border-[#0F1DD7]/25 rounded-full px-4 py-2 hover:bg-[#0F1DD7]/[0.18]'
					: 'font-medium text-[#4B5563] hover:text-[#0F1DD7]',
			)}
		>
			{children}
		</Link>
	);

	// Para mobile, envolver com Close para fechar o menu automaticamente
	if (mobile) {
		return <Close asChild>{linkElement}</Close>;
	}

	return linkElement;
};

export default NavbarLink;
